import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ICategory } from '../categories.interface';
import { CategoriesService } from '../categories.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-categories-modal',
  templateUrl: './categories-modal.component.html',
  styleUrls: ['./categories-modal.component.css']
})
export class CategoriesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  category!: ICategory;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  action: string = '';

  constructor(
    public _CategoriesService: CategoriesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.category._id) {
      this.action = 'Modificar';
      this.getCategory(); 
    }
    else {
      this.action = 'Nueva';
      this.buildForm();
    }
  }

  getCategory() {
    this.loading = true;
    this._CategoriesService.getCategory(this.category._id || '').subscribe((category) => {
      this.category = category;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.category.name, [Validators.required]],
      isDeleted: [this.category.isDeleted]
    });
  }

  setEditable( value:boolean = false) {
    this.readOnly = value;
  }

  onSubmit() {
    this.submitted = true;
    let data: ICategory = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();
    if (this.category._id) {
      data._id = this.category._id;
      this._CategoriesService.updateCategory(data).subscribe((category) => {
        this.dialog.close(category);
      });
    } else {
      this._CategoriesService.createCategory(data).subscribe((category) => {
        this.dialog.close(category);
      });
    }
  }

  cancelSubmit() {
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getCategory();
  }

}